import { render, staticRenderFns } from "./xxzykIndex.vue?vue&type=template&id=ddfd98ac&scoped=true&"
import script from "./xxzykIndex.vue?vue&type=script&lang=js&"
export * from "./xxzykIndex.vue?vue&type=script&lang=js&"
import style0 from "./xxzykIndex.vue?vue&type=style&index=0&id=ddfd98ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfd98ac",
  null
  
)

export default component.exports